module.exports = __webpack_public_path__ + "img/character05_static.4142ba05.png";